module.exports = __webpack_public_path__ + "assets/img/pjs_1.95ffffa9.png";